<cac-dialog-layout title="جزئیات مکان" [hideControls]="true">
    <app-location-details [location]="data" (submit)="onSubmit($event)"></app-location-details>
</cac-dialog-layout>
